import BtsView from '@/pages/bts/BtsView';
import BtsUpload from '@/pages/bts/BtsUpload';
import BtsProposal from '@/pages/bts/BtsProposal';
import ProposalProduct from '@/pages/bts/ProposalProduct';

const btsRoutes = [
  { path: 'bts', element: BtsView },
  { path: 'bts/upload', element: BtsUpload },
  { path: 'bts/create-proposal', element: BtsProposal },
  { path: 'bts/proposal-product/:id', element: ProposalProduct },
];

export default btsRoutes;
